<template>
  <div>
    <el-dialog
        :visible.sync="isOpenInvoiceSendAppDialog"
        width="1000px"
        :before-close="closeDialog"
        :close-on-click-modal="false"
        top="3vh"
        title="Gửi thông báo hóa đơn điện tử qua App cho học sinh"
    >
      <el-form
          label-width="140px"
          :model="createStudentNotify"
          label-position="left"
          :rules="rules"
          ref="createStudentNotify"
      >
        <el-row :gutter="40">
          <el-col :span="24">
            <div class="grid-content">
              <el-form-item label="Tiêu đề" prop="sendTitle">
                <el-input
                    placeholder="Nhập tiêu đề"
                    v-model="createStudentNotify.sendTitle"
                ></el-input>
              </el-form-item>
              <el-form-item label="Nội dung" prop="sendContent">
                <el-input
                    :rows="7"
                    type="textarea"
                    placeholder="Nhập nội dung..."
                    v-model="createStudentNotify.sendContent"
                ></el-input>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <div class="tab-infor-button">
        <el-button
            type="success"
            size="medium"
            :loading="loadingButton"
            mini
            @click="submitForm('createStudentNotify')"
        >
          <i class="el-icon-circle-check"/>
          <span>Gửi</span>
        </el-button>
        <el-button
            type="danger"
            size="medium"
            @click="closeDialogByButton('createStudentNotify')"
        >
          <i class="el-icon-circle-close"/>
          <span>Đóng</span>
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import financeKidsV2Service from "@/services/Finance_Kids_V2/FinanceKidsV2Service";


import electronicInvoicesService from "@/services/ElectronicInvoicesService";

export default {
  name: "InvoiceSendAppDialog",
  props: {
    isOpenInvoiceSendAppDialog: {
      type: Boolean,
      default: () => false,
    },
    transactionUuid: {
      type: Array,
      default: () => [],
    }

  },
  data() {
    return {
      disabled: false,
      loadingButton: false,
      createStudentNotify: {
        sendTitle: "Thông báo gửi hóa đơn điện tử đến phụ huynh",
        sendContent: "Kính gửi Quý phụ huynh,\n" +
            "\n" +
            "Nhà trường xin thông báo hóa đơn điện tử học phí đã được phát hành.\n" +
            "Phụ huynh vui lòng xem chi tiết hóa đơn trong mục đính kèm.\n" +
            "\n" +
            "Mọi thắc mắc cần hỗ trợ, phụ huynh vui lòng liên hệ nhà trường.\n" +
            "\n" +
            "Trân trọng.",
        date: "",
        transactionUuid: [],
      },

      notification: null,

      rules: {
        sendTitle: [
          {
            required: true,
            message: "Tiêu đề không được để trống",
            trigger: "blur",
          },
        ],
        sendContent: [
          {
            required: true,
            message: "Nội dung không được để trống",
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    tableHeaderColor() {
      return "background-color: #78a5e7;color: #fff;font-weight: bold;border:1px solid #fff";
    },
    closeDialog() {
      this.$refs["createStudentNotify"].resetFields();
      this.$emit("close", false);
    },
    //click when click button
    closeDialogByButton() {
      this.createStudentNotify.sendTitle = "";
      this.createStudentNotify.sendContent = "";
      this.$emit("close", false);
    },
    handleClose(done) {
      this.$confirm("Are you sure to close this dialog?")
          .then(() => {

            done();
          })
          .catch((error) => {
            console.log(error)
          });
    },
    submitForm(fromData) {
      this.$refs[fromData].validate((valid) => {
        if (valid) {
          // this.loadingButton = true;
          this.createStudentNotify.transactionUuid = this.$props.transactionUuid
          electronicInvoicesService.createOrderExcelNotifyForApp(this.createStudentNotify)
              .then((response) => {
                if (response.data.message === "Chưa kích hoạt") {
                  this.$message({
                    message: "PHHS chưa kích hoạt tài khoản",
                    type: "error",
                    duration: 5000
                  });
                } else {
                  this.$message({
                    message: response.data.message,
                    type: "success",
                  });
                }
              })
              .catch((err) => {
                this.$message({
                  message: err.response.data.message,
                  type: "error",
                });

              })
              .finally(() => {
                this.notification.close();
                setTimeout(() => {
                  this.closeDialogByButton(fromData);
                  this.loadingButton = false;
                }, 500);
              });
        } else {
          return false;
        }
      });
    },


  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-dialog__title {
  font-size: 25px;
  color: #606266;
}

/deep/ .el-form-item__label {
  font-family: Arial, Helvetica, sans-serif;
}

/deep/ .el-button--primary {
  width: 100%;
  background: #409eff;
}

/deep/ .upload-demo {
  text-align: center;

  .el-upload {
    width: 100%;
  }
}

/deep/ .el-avatar {
  display: inline;

  img {
    border-radius: 5px;
    width: 100%;
  }
}

/deep/ .el-input.is-disabled .el-input__inner {
  text-align: center;
  color: #d13b93;
  font-weight: bold;
}

.el-select {
  display: block;
}

.tab-infor-button {
  text-align: right;
  margin-top: 20px;
}

.bg-purple {
  background: #d3dce6;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

.group-radio-status {
  margin: 0 50px;

  .kids-status {
    margin-bottom: 10px;
  }
}

/deep/ .el-tabs__nav {
  background: #a0a19ce0;
}

/deep/ .el-tabs__item {
  color: white;
}

/deep/ .el-tabs__item.is-active {
  color: white;
  background: #67c23a;
}

/deep/ .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:after {
  content: "*";
  color: #f56c6c;
  margin-left: 3px;
}

/deep/ .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
  content: "";
  color: #f56c6c;
  margin-left: -4px;
}

.table-icon-1 {
  width: 30%;
  margin-left: 15%;
  display: inline-block;
}

.table-icon-2 {
  width: 30%;
  margin-right: 15%;
  float: right;
}


/deep/.el-notification__icon {
  color: #67c23a;
}

</style>
